import { Route, Routes } from "react-router-dom";
import { AboutPage } from "../pages/AboutPage";
import { AuthorPage } from "../pages/AuthorPage";
import { CategoryPage } from "../pages/CategoryPage";
import { Home } from "../pages/Home";
import { NotFound } from "../pages/NotFound";
import { PostPage } from "../pages/PostPage";
import { SearchPage } from "../pages/SearchPage";
import { TagPage } from "../pages/TagPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/wiki/:slug" element={<PostPage />} />
      <Route path="/category/:slug" element={<CategoryPage />} />
      <Route path="/tag/:slug" element={<TagPage />} />
      <Route path="/author/:slug" element={<AuthorPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
